/**
 * ColorZilla
 *
 * Declares css/content-style.css, which is not actually shipped — same stale-manifest
 * pattern seen in WPS PDF. The images/* grant resolves to real files, so the probes
 * use those.
 * Manifest verified against version 4.1.
 */
import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'bhlhnicpbhignbdhedgjhgdocnmhomnp';
export const colorzilla: ExtensionDefinition = {
  id: ID,
  name: 'ColorZilla',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 4_000_000,
  notes: 'Declares a stylesheet it does not ship; detection uses the images/* grant instead.',
  signals: [
    { id: 'war-icon-128', kind: 'web-accessible-resource',
      description: 'Load images/icon-128.png via <img>, matched by the images/* grant to <all_urls>.',
      weight: 1, run: () => probeImage(ID, 'images/icon-128.png') },
    { id: 'war-checkmark-icon', kind: 'web-accessible-resource',
      description: 'Load images/checkmark-icon.svg via <img> to corroborate.',
      weight: 0.5, run: () => probeImage(ID, 'images/checkmark-icon.svg') },
  ],
};
